"use strict";

/**
 * Controlla che il valore sia non null in presenza di altri campi
 * 
 * @class
 * @param {$translate} $translate
 */
function RequiredWithFct($translate){
    
    /**
     * Definisce il messaggio da mostrare in caso di validazione fallita. 
     * Il messaggio viene ottenuto dal servizio $translate. 
     * Viene data la possibilità di passare chiave di validazione e parametri (oppure il messaggio) quando si istanzia il validatore.
     * Priorità:
     * - messaggio
     * - chiave e parametri
     * - chiave di default
     * 
     * @memberOf RequiredFct
     * @constructor
     * @param {string} [messaggio = null] stringa con il messaggio di validazione
     * @param {string} [chiave = null] chiave di traduzione
     * @param {Object} [parametri = null] parametri da passare, può servire solo nel caso in cui è presente la chiave
     */     
    function Costruttore(messaggio, chiave, parametri){
        var self = this;
        $translate(chiave || "VALIDATORI.REQUIREDWITH", parametri).then(function(_defaultMessage){
            self.message = messaggio || _defaultMessage;
        });
    }
    
    Costruttore.prototype.expression = expression;
    
    /**
     * Applica la regola di validazione e ritorna un boolean
     * 
     * @memberOf RequiredFct
     * @param {type} viewValue
     * @param {type} modelValue
     * @param {type} scope
     * @returns {Boolean}
     */     
    function expression(viewValue, modelValue, scope){
        var valore = modelValue || viewValue || null;
        var esitoValore = valore !== null && typeof valore !== 'undefined';
        
        var altriCampi = scope.options.data.modello.validations.required_with;
        
        scope.options.altreLabel = _.without(_.map(scope.options.data.modello.validations.required_with, function(campo){
            if(scope.$parent.$parent.$parent !== null){
                var campiForm = scope.$parent.$parent.$parent.fields;
                var campoForm = _.findWhere(campiForm, {key: campo});
                if( typeof campoForm !== 'undefined' ) return campoForm.templateOptions.label;
                return null;
            }
            else return null;            
        }), null);        
        
        console.log("required_with campo: ", scope.to.label, "altre label: ", scope.options.altreLabel , "altri campi: ", altriCampi);
        
        for(var x = 0; x < altriCampi.length; x++){            
            var altroValore = scope.model[altriCampi[x]];
            var esitoAltroValore = (altroValore !== null && typeof altroValore !== 'undefined' && altroValore !== '');   
            console.log("valore", scope.to.label, "definito? ", esitoValore, "altro valore", altriCampi[x] ,"definito? ", esitoAltroValore);
            if(esitoAltroValore && !esitoValore) return false;
        }
        
        
        
        return true;
    }
        
    return Costruttore;
}

module.exports = RequiredWithFct;